module.exports = __webpack_public_path__ + "img/danique.db0b4a32.jpg";